<template>
  <div class="Notice">
    <div class="page-title">{{ title }}</div>
    <ATable
      ref="table"
      max-height="750px"
      :data="items"
      :loading="loading"
      :search_field="search_field"
      :placeholder="placeholder"
      :disable_insert="!has_grant_write"
      hide-pagination
      border
      @row-click="handleClickRow"
      @clicked-create="handleClickedCreate"
    >
      <div slot="search">
        <div class="inline">
          <APeriodSelector ref="period" @change="handleChangePeriod" />
        </div>
        <div class="inline">
          <el-button
            type="primary"
            size="mini"
            round
            v-shortkey="['f5']"
            @shortkey.native="handleClickSearch"
            @click="handleClickSearch"
          >검색(F5)</el-button>
        </div>
      </div>
      <el-table-column 
        type="index" 
        label="No" 
        :index="handleIndex" 
        :width="$width.index"
      />
      <el-table-column 
        prop="title" 
        label="제목" 
        show-overflow-tooltip
      />
      <el-table-column  
        label="부서" 
        width="200"
        :formatter="resolveBranch"
        show-overflow-tooltip
      />
      <el-table-column 
        label="그룹" 
        width="200"
        :formatter="resolveUserGroup"
        show-overflow-tooltip
      />
      <el-table-column 
        prop="begin_date" 
        label="시작일" 
        :width="$width.date"
      />
      <el-table-column 
        prop="end_date" 
        label="종료일" 
        :width="$width.date"
      />
      <el-table-column
        prop="created_user_name"
        :label="$t('lang.created_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        :label="$t('lang.modified_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="created_at"
        :label="$t('lang.created_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="modified_at"
        :label="$t('lang.modified_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
    </ATable>

    <el-dialog
      top="0"
      width="600px"
      custom-class="form-dialog"      
      :title="title"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      destroyOnClose
      @opened="handleOpened"
    >
      <NoticeForm 
        ref="form" 
        v-if="dialog_visible"
        :data="form_data" 
        :has_grant_write="has_grant_write"
        @completed="handleCompleted" 
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import NoticeForm from "./NoticeForm";

export default {
  name: "Notice",
  mixins: [form_container, authority_level],
  components: { NoticeForm },
  data() {
    return {
      title: this.$t('title.notice'),
      dialog_visible: false,
      loading: false,
      items: [],
      form_data: undefined,
      search_field: ["title", "content"],
      placeholder: "제목, 내용",
      period: {},
    };
  },
  computed: {
    ...mapGetters(["table_branch", "table_user_group"]),    
    has_grant_write() {      
      return this.isWriteLevel('notice');
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.api.listNotice(this.period).then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
      });
    },
    handleClickRow(data) {
      this.openDialog(data);
    },
    openDialog(data) {
      // let clone = data ? Object.assign({}, data) : undefined;
      let clone = data ? this.util.looseClone(data) : undefined;
      this.form_data = clone;
      this.dialog_visible = true;
    },
    resolveBranch(row) {
      if (row.branch_all_flag === 'Y') {
        return '전체'
      } else if (!row.branch_ids) {
        return ''
      } else {
        let result = "";
        row.branch_ids.forEach(id => {
          let branch = this.table_branch.find(b => b.id === id);
          if (result.length > 0) {
            result += ", ";
          }
          result += branch.name;
        });
        return result;
      }
    },
    resolveUserGroup(row) {
      if (row.user_group_all_flag === 'Y') {
        return '전체'
      } else if (!row.user_group_ids) {
        return ''
      } else {
        let result = "";
        row.user_group_ids.forEach(id => {
          let group = this.table_user_group.find(g => g.id === id);
          if (result.length > 0) {
            result += ", ";
          }
          result += group.name;
        });
        return result;
      }
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) { return; }
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickedCreate() {
      this.openDialog();
    },
    handleCompleted(result) {
      this.dialog_visible = false;
      this.form_data = undefined;
      if (!result) { return; }
      this.loadData();
    },
  },
};
</script>
